import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { useGetAnalysisClients } from "Infrastructure/ApiZfp/AnalyzerApi";
import { AnalysisClientItemRelationType } from "Infrastructure/ApiZfp/Schema";
import { useContext } from "react";

export const useClientBirthDate = () => {
  const { analysisId, versionId } = useContext(AnalysisDetailContext);
  const { data } = useGetAnalysisClients(analysisId, versionId, {
    query: {
      select: ({ clients }) => clients.find((client) => client.relationType === AnalysisClientItemRelationType.Client)?.birthDate ?? null,
    },
  });

  return data ?? null;
};
